var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8578",
    "data-name": "Group 8578",
    transform: "translate(-217 -83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M17.3,3.8H15.5V2.9a.9.9,0,0,0-1.8,0v.9H8.3V2.9a.9.9,0,0,0-1.8,0v.9H4.7A2.7,2.7,0,0,0,2,6.5V17.3A2.7,2.7,0,0,0,4.7,20H17.3A2.7,2.7,0,0,0,20,17.3V6.5a2.7,2.7,0,0,0-2.7-2.7Zm.9,13.5a.9.9,0,0,1-.9.9H4.7a.9.9,0,0,1-.9-.9V11H18.2Zm0-8.1H3.8V6.5a.9.9,0,0,1,.9-.9H6.5v.9a.9.9,0,0,0,1.8,0V5.6h5.4v.9a.9.9,0,1,0,1.8,0V5.6h1.8a.9.9,0,0,1,.9.9Z",
    transform: "translate(215 81)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8575",
    "data-name": "Group 8575",
    transform: "translate(1 -1.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(221 96)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(224 96)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(227 96)",
    fill: "#434db8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.80b3997d22249f7efd834621cd0be772.svg";
export { ForwardRef as ReactComponent };